import styled from 'styled-components';
import { Button } from 'components';

export const TestToneActionButton = styled(Button).attrs({
  variant: 'outline',
  className:
    'shrink-0 rounded-lg border-primary bg-white font-medium text-primary hover:bg-vantis-silver hover:text-primary',
})``;
